module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1055.df4fa90f.png";